import SubHeader from "../../components/header/SubHeader";
import Button from "../../components/common/button/Button";
import React, {useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";
import {fetchProductList} from "../../store/list-slice";
import {fetchTagById} from "../../store/tag-slice";
import Form from "../../components/common/form/Form";
import {assignTagSchema, unassignedTagSchema} from "../../schema/tagSchema";
import {getAssignFormData, getUnassignedFormData} from "../../models/tagModel";
import {useNavigate, useParams} from "react-router-dom";
import {fromCamelCaseToTitle, getValidatedLimit} from "../../components/Utility";
import {AssignTagToProducts, UnassignedTagFromProducts} from "../../store/tag-slice";


const TagAssign = () => {
    const params = useParams();
    const dispatch = useDispatch();
    const navigator = useNavigate();
    const userRole = useSelector((state) => state.auth.selectedRole);
    const {
        items,
        fetchByIdStatus,
    } = useSelector(state => state.tag);

    const list = useSelector(state => state.list);
    const {
        items: productList,
    } = list.product;

    const tagName = fromCamelCaseToTitle(params.tag);

    const item = items.find(item => item.id === params.tagId);
    const products = item?.products || [];

    const {assignTagStatus, unassignedTagStatus, error, pagination} = useSelector(state => state.tag)
    const {limit, currentPage} = getValidatedLimit(pagination);

    //To display the name of the products which are already have this tag
    const productNames = products
        .filter(id => productList[id])
        .map(id => productList[id])
        .join(", ");

    const isAssignedProduct = products.some(productId => productList.hasOwnProperty(productId));

    useEffect(() => {
        dispatch(fetchProductList({...userRole, tagId: params.tagId}));
        dispatch(fetchTagById({...userRole, id: params.tagId}));
    }, [dispatch, userRole, params.tagId])

    const formSubmitHandlerAssigned = (data) => {
        const updatedData = {
            ...data,
            apply: Number(data.apply),
            id: userRole.scopeId,
            tag: params.tagId
        }
        dispatch(AssignTagToProducts({...userRole, data: updatedData}));
    };

    const formSubmitHandlerUnassigned = (data) => {
        const updatedData = {
            ...data,
            apply: Number(data.apply),
            id: userRole.scopeId,
            tag: params.tagId
        }
        dispatch(UnassignedTagFromProducts({...userRole, data: updatedData}));
    };

    useEffect(() => {
        if (assignTagStatus === "success" || unassignedTagStatus === "success") {
            navigator("../../");
        }
    }, [assignTagStatus, unassignedTagStatus, navigator]);

    const formCancelHandler = () => {
        navigator("../../");
    };

    const initialDataAssigned = getAssignFormData();
    const initialDataUnassigned = getUnassignedFormData()
    const schemaAssigned = assignTagSchema({list, products});
    const schemaUnassigned = unassignedTagSchema({list, products})

    return (
        <>
        <SubHeader title={`Assign / Unassign Tags - ${tagName}`} >
                <Button to={`../../?page=${currentPage}&limit=${limit}`}
                        className="btn-sm bg-secondary bg-opacity-50">Back</Button>
            </SubHeader>
            <div className="container p-0 ms-0">
                <div className="row">
                    <div className="col-xl-6">
                        {
                            fetchByIdStatus === "success" &&
                            <>
                                <h6>Assign Tag to Products</h6>
                                {isAssignedProduct && <div>
                                    <label className="form-label opacity-75" htmlFor="assignedTo">Tag Used in
                                        Products</label>
                                    <textarea className="form-control mb-3 text-secondary" name="assignedTo"
                                              value={productNames} readOnly/>
                                </div>}
                                <Form
                                    onFormSubmit={formSubmitHandlerAssigned}
                                    onFormCancel={formCancelHandler}
                                    initialData={initialDataAssigned}
                                    schema={schemaAssigned}
                                    inline={false}
                                    status={assignTagStatus}
                                    error={error}
                                />

                                {isAssignedProduct && <>
                                    <h6 className="mt-8">Remove Assigned Tag</h6>
                                    <Form
                                        onFormSubmit={formSubmitHandlerUnassigned}
                                        onFormCancel={formCancelHandler}
                                        initialData={initialDataUnassigned}
                                        schema={schemaUnassigned}
                                        inline={false}
                                        status={unassignedTagStatus}
                                        error={error}
                                    />
                                </>}
                            </>
                        }
                    </div>
                </div>
            </div>
        </>
    )
}

export default TagAssign;